"use client";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsxs as s, jsx as e } from "react/jsx-runtime";
import { useTheme as i, useAriaId as n } from "../hooks.js";
import { getAnimateCircleScaleInProps as c, getAnimateDrawLineProps as l } from "../utils/animation.js";
const d = (param)=>{
    let { size: o = 48 } = param;
    const { platformOverrides: r } = i(), t = n();
    return /* @__PURE__ */ s("svg", {
        role: "presentation",
        width: o,
        height: o,
        viewBox: "0 0 64 64",
        fill: "none",
        children: [
            /* @__PURE__ */ e("circle", _object_spread({
                cx: "32",
                cy: "32",
                r: "31",
                stroke: `url(#${t})`
            }, c("31", r))),
            /* @__PURE__ */ e("polyline", _object_spread({
                fill: "none",
                stroke: "white",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                points: "24,32.75 30,39 40.5,24.5"
            }, l("44", "0.4s", r, "0.5 0 0.83 0.83"))),
            /* @__PURE__ */ e("defs", {
                children: /* @__PURE__ */ s("linearGradient", {
                    id: t,
                    x1: "6.66663",
                    y1: "6.66669",
                    x2: "58.3441",
                    y2: "7.98638",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /* @__PURE__ */ e("stop", {
                            stopColor: "#E5B9FF"
                        }),
                        /* @__PURE__ */ e("stop", {
                            offset: "1",
                            stopColor: "#FF6ACE"
                        })
                    ]
                })
            })
        ]
    });
}, m = d;
export { m as default };
